import axiosClient from "../../axios";


export async function storeCreateProduct({ commit }, { product, value_id, tag_id, product_gallery }) {

    const form = new FormData();
    form.append('category_id', product.selectedCategory);
    form.append('product_name', product.product_name);
    form.append('product_price', product.product_price);
    form.append('product_inventory', product.product_inventory);
    form.append('discount_percent', product.discount_percent);
    form.append('discount_price', product.discount_price);
    form.append('long_description', product.long_description);
    form.append('meta_title', product.meta_title);
    form.append('meta_keywords', product.meta_keywords);
    form.append('meta_description', product.meta_description);
    form.append('featured', product.featured ? 1 : 0);
    form.append('special_sale', product.special_sale ? 1 : 0);
    form.append('incredible_offer', product.incredible_offer ? 1 : 0);
    form.append('incredible_offer_discount_percent', product.incredible_offer_discount_percent);
    form.append('incredible_offer_discount_price', product.incredible_offer_discount_price);
    form.append('incredible_offer_hour', product.incredible_offer_hour);
    form.append('supply_and_shipping_time', product.supply_and_shipping_time);
    form.append('product_image', product.product_image);

    for (let j = 0; j < value_id.length; j++) {
        form.append('valueId[]', value_id[j])
    }

    for (let j = 0; j < tag_id.length; j++) {
        form.append('tagId[]', tag_id[j])
    }

    for (let i = 0; i < product_gallery.length; i++) {
        form.append('productGallery[]', product_gallery[i]);
    }

    /* if (form.has('file[]')) {
        let filesArray = form.getAll('file[]');
        console.log(filesArray);
      } else {
        console.log("فیلد file[] وجود ندارد")
      } */

    product = form;

    return await axiosClient.post('/products', product)
}

export async function storeGetProducts({ commit, state }, { url = null, search = '', status, per_page, sort_field, sort_direction } = {}) {
    commit('setProducts', [true])
    url = url || "/products"
    const params = {
        per_page: state.products.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            search, status, per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setProducts', [false, response.data])
        })
        .catch(() => {
            commit('setProducts', [false])
        })
}


export function storeUpdateProduct({ commit }, { product, value_id, tag_id, product_gallery }) {

    const id = product.value.id
    const form = new FormData();

    form.append('id', product.id);
    form.append('category_id', product.value.category_id);
    form.append('product_name', product.value.product_name);
    form.append('product_price', product.value.product_price);
    form.append('product_inventory', product.value.product_inventory);
    form.append('discount_percent', product.value.discount_percent || '');
    form.append('discount_price', product.value.discount_price || '');
    form.append('long_description', product.value.long_description || '');
    form.append('meta_title', product.value.meta_title || '');
    form.append('meta_keywords', product.value.meta_keywords || '');
    form.append('meta_description', product.value.meta_description || '');
    form.append('featured', product.value.featured ? 1 : 0);
    form.append('special_sale', product.value.special_sale ? 1 : 0);
    form.append('incredible_offer', product.value.incredible_offer ? 1 : 0);
    form.append('incredible_offer_discount_percent', product.value.incredible_offer_discount_percent || '');
    form.append('incredible_offer_discount_price', product.value.incredible_offer_discount_price || '');
    form.append('incredible_offer_hour', product.value.incredible_offer_hour || '');
    form.append('supply_and_shipping_time', product.value.supply_and_shipping_time || '');
    form.append('status', product.value.status ? 1 : 0);

    for (let j = 0; j < value_id.length; j++) {
        form.append('valueId[]', value_id[j])
    }

    for (let j = 0; j < tag_id.length; j++) {
        form.append('tagId[]', tag_id[j])
    }

    if (product_gallery.length > 0) {
        for (let i = 0; i < product_gallery.length; i++) {
            form.append('productGallery[]', product_gallery[i]);
        }
    }


    if (product.value.product_image instanceof File) {
        form.append('product_image', product.value.product_image);
    } else {
        form.append('product_image', '');
    }

    form.append('_method', 'PUT');
    product = form;

    return axiosClient.post(`/products/${id}`, product)
}


export async function getStoreInfo({ commit }) {
    return await axiosClient.get("/seller/details")
}

export function updateStoreDetails({ commit }, { storeDetailsData }) {


    const form = new FormData();

    form.append('instagram', storeDetailsData.value.instagram);
    form.append('whatsapp', storeDetailsData.value.whatsapp);
    form.append('latitude', storeDetailsData.value.latitude || '');
    form.append('longitude', storeDetailsData.value.longitude || '');
    form.append('slogan', storeDetailsData.value.slogan);
    form.append('working_hours', storeDetailsData.value.working_hours);
    form.append('store_address', storeDetailsData.value.store_address);
    form.append('contact_info', storeDetailsData.value.contact_info);

    if (storeDetailsData.value.store_logo instanceof File) {
        form.append('store_logo', storeDetailsData.value.store_logo);
    } else {
        form.append('store_logo', '');
    }

    storeDetailsData = form;

    return axiosClient.post('/seller/store/details/edit', storeDetailsData)
}

export async function getAllStoreOrders({ commit, state }, { url = null, search = '', order_status, per_page, sort_field, sort_direction } = {}) {
    commit('setAllStoreSales', [true])
    url = url || "/seller/orders"
    const params = {
        per_page: state.allStoreSales.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            search, order_status, per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setAllStoreSales', [false, response.data])
            return response
        })
        .catch(() => {
            commit('setAllStoreSales', [false])
        })
}

export async function getUnsettledProducts({ commit }) {
    return await axiosClient.get(`/seller/unsettled-products`)
}

export async function getAllSettlementPayments({ commit, state }, { url = null, per_page, sort_field, sort_direction } = {}) {
    commit('setAllStoreSettlements', [true])
    url = url || "/seller/settlement-payments"
    const params = {
        per_page: state.allStoreSales.limit,
    }

    return await axiosClient.get(url, {
        params: {
            ...params,
            per_page, sort_field, sort_direction
        }
    })
        .then((response) => {
            commit('setAllStoreSettlements', [false, response.data])
            return response
        })
        .catch(() => {
            commit('setAllStoreSettlements', [false])
        })
}